import { createAsyncThunk } from '@reduxjs/toolkit';
import api from 'api';
import { API_COMMON_GOAL_TEMPLATES } from 'constants/api';
import { storeName } from '../config';
import { CommonGoalsByCategory } from '../interfaces/CommonGoalsByCategory';

export const getCommonGoalsList = createAsyncThunk<{
  items: CommonGoalsByCategory[];
}>(`${storeName}/getCommonGoalsList`, async (data, thunkAPI) =>
  api.axios
    .get<{ items: CommonGoalsByCategory[] }>(API_COMMON_GOAL_TEMPLATES)
    .then((res) => {
      const { items } = res.data;

      return {
        items,
      };
    })
    .catch((e) => thunkAPI.rejectWithValue(e.response?.data)),
);
